import { useEffect, useState } from 'react';
import { useDownload } from '../../contexts/Download';
import { ModalForms } from '../Modal';

const LoadedPostDown = (props) => {
  const [modal, setModal] = useState(false);
  const { setClickDownload } = useDownload();
  const [formId, setFormId] = useState(15);
  useEffect(() => {
    setClickDownload(true);
  }, []);
  useEffect(() => {
    const { pathname } = window.location;
    const url = pathname.split('/');
    const path = url[2];

    const formIdMap = {
      'baixar-video-instagram': 15,
      'baixar-reels-instagram': 17,
      'baixar-foto-instagram': 11,
      'baixar-story-instagram': 13,
      'baixar-foto-perfil-instagram': 19,
      // Add more cases here as needed
    };
    const formIdValue = formIdMap[path] || 15;

    setFormId(formIdValue);
  }, []);

  let responseObj = props.responseObj;
  console.log('🚀 ~ file: LoadedPost.jsx:12 ~ responseObj:', props);

  // If no post found
  if (responseObj.message) {
    return (
      <div className="error-page">
        <h1>No post found !</h1>
        <p>Make sure you've entered proper link.</p>
      </div>
    );
  }

  const openModal = () => {
    setModal(!modal);
    setClickDownload(true);
    console.log('aaaaaaaaaaa', modal);
  };
  function ImageComponent(url) {
    const imageBuffer = url; // Substitua pelo buffer real retornado pela API em Node.js
    const blob = new Blob([new Uint8Array(imageBuffer)], {
      type: 'image/jpeg',
    });
    const imageUrl = URL.createObjectURL(blob);

    console.log(
      '🚀 ~ file: LoadedPost.jsx:32 ~ ImageComponent ~ imageUrl:',
      imageUrl,
    );

    return (
      <section className="story-list">
        <div className="position-relative">
          <div className="row justify-content-center">
            <div className="story-item col-md-4 col-12 m-3 position-relative">
              <img
                src={`${imageUrl}`}
                className="story-item "
                alt=""
                style={{
                  borderRadius: '8px',
                }}
              />
              <div onClick={openModal}>
                <a
                  className="buttonDownload position-absolute"
                  target="_blank"
                  href={imageUrl}
                  rel="noreferrer"
                >
                  BAIXAR
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
  function VideoComponent(url, type) {
    let imageUrl = url.data; // Substitua pelo buffer real retornado pela API em Node.js
    if (type === 'buffer') {
      // Substitua pelo buffer real retornado pela API em Node.js
      const blob = new Blob([new Uint8Array(imageUrl)], {
        type: 'video/mp4',
      });
      imageUrl = URL.createObjectURL(blob);
    }

    return (
      <section className="story-list">
        <div className="position-relative">
          <video
            className="story-item"
            style={{
              borderRadius: '8px',
            }}
            // controls
            // poster={responseObj.url_download}
          >
            <source
              src={type === 'url' ? url : imageUrl}
              className="story-media"
              type="video/mp4"
            ></source>
          </video>
          <div onClick={openModal}>
            <a
              className="buttonDownload position-absolute"
              target="_blank"
              href={type === 'url' ? url : imageUrl}
              rel="noreferrer"
            >
              BAIXAR
            </a>
          </div>
        </div>
      </section>
    );
  }
  function ReelsComponent(url, type) {
    console.log(
      '🚀 ~ file: LoadedPost.jsx:112 ~ ReelsComponent ~ type:',
      type,
      url,
    );
    let imageUrl = '';
    if (type === 'buffer') {
      const imageBuffer = url; // Substitua pelo buffer real retornado pela API em Node.js
      const blob = new Blob([new Uint8Array(imageBuffer)], {
        type: 'video/mp4',
      });
      imageUrl = URL.createObjectURL(blob);
    }

    return (
      <section className="story-list">
        <div className="position-relative">
          <video
            className="story-item"
            style={{
              borderRadius: '8px',
            }}
            // controls
            // poster={responseObj.url_download}
          >
            <source
              src={type === 'url' ? url : imageUrl}
              className="story-media"
              type="video/mp4"
            ></source>
          </video>
          <div onClick={openModal}>
            <a
              className="buttonDownload position-absolute"
              target="_blank"
              href={type === 'url' ? url : imageUrl}
              rel="noreferrer"
            >
              BAIXAR
            </a>
          </div>
        </div>
      </section>
    );
  }
  function SideCarComponent(urls) {
    const urlsImage = urls.map((url) => {
      const imageBuffer = url.data; // Substitua pelo buffer real retornado pela API em Node.js
      const blob = new Blob([new Uint8Array(imageBuffer)], {
        type: 'image/png',
      });
      return URL.createObjectURL(blob);
    });
    console.log(
      '🚀 ~ file: LoadedPost.jsx:32 ~ ImageComponent ~ imageUrl:',
      urlsImage,
    );

    return (
      <section className="story-list">
        <div className="position-relative">
          <div className="row justify-content-center">
            {urlsImage.map((img) => {
              return (
                <div className="story-item col-md-4 col-12 m-3 position-relative">
                  <img
                    src={img}
                    className="story-item "
                    alt=""
                    style={{
                      borderRadius: '8px',
                    }}
                  />
                  <div onClick={openModal}>
                    <a
                      className="buttonDownload position-absolute"
                      target="_blank"
                      href={img}
                      rel="noreferrer"
                    >
                      BAIXAR
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      // <section className="story-list">
      //   <div className="position-relative">
      //     <video
      //       className="story-item"
      //       style={{
      //         borderRadius: '8px',
      //       }}
      //       // controls
      //       // poster={responseObj.url_download}
      //     >
      //       <source
      //         src={imageUrl}
      //         className="story-media"
      //         type="video/mp4"
      //       ></source>
      //     </video>
      //     <div onClick={openModal}>
      //       <a
      //         className="buttonDownload position-absolute"
      //         target="_blank"
      //         href={imageUrl}
      //         rel="noreferrer"
      //       >
      //         BAIXAR
      //       </a>
      //     </div>
      //   </div>
      // </section>
    );
  }
  function PhotoComponent(url) {
    const imageBuffer = url; // Substitua pelo buffer real retornado pela API em Node.js
    const blob = new Blob([new Uint8Array(imageBuffer)], {
      type: 'video/mp4',
    });
    const imageUrl = URL.createObjectURL(blob);

    console.log(
      '🚀 ~ file: LoadedPost.jsx:32 ~ ImageComponent ~ imageUrl:',
      imageUrl,
    );

    return (
      <section className="story-list">
        <div className="position-relative">
          <div className="row justify-content-center">
            {responseObj.url_download.map((img) => {
              return (
                <div className="story-item col-md-4 col-12 m-3 position-relative">
                  <img
                    src={img}
                    className="story-item "
                    alt=""
                    style={{
                      borderRadius: '8px',
                    }}
                  />
                  <div onClick={openModal}>
                    <a
                      className="buttonDownload position-absolute"
                      target="_blank"
                      href={img}
                      rel="noreferrer"
                    >
                      BAIXAR
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
  function SinglePhotoComponent(url) {
    const imageBuffer = url; // Substitua pelo buffer real retornado pela API em Node.js
    const blob = new Blob([new Uint8Array(imageBuffer)], {
      type: 'image/jpeg',
    });
    const imageUrl = URL.createObjectURL(blob);

    console.log(
      '🚀 ~ file: LoadedPost.jsx:32 ~ ImageComponent ~ imageUrl:',
      imageUrl,
    );

    return (
      <section className="story-list">
        <div className="position-relative">
          <div className="row justify-content-center">
            <div className="story-item col-md-4 col-12 m-3 position-relative">
              <img
                src={imageUrl}
                className="story-item "
                alt=""
                style={{
                  borderRadius: '8px',
                }}
              />
              <div onClick={openModal}>
                <a
                  className="buttonDownload position-absolute"
                  target="_blank"
                  href={imageUrl}
                  rel="noreferrer"
                >
                  BAIXAR
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <>
      <div className="post-head">
        {/* <header className="reel-header">
          <div className="reel-creator">
            <img
              src={responseObj.user.profile_pic_url}
              className="profile-picture"
              alt="profile"
            />
            <div className="creator-info">
              <h3>{responseObj.user.username}</h3>
              <p>{responseObj.user.full_name}</p>
            </div>
          </div>
        </header> */}

        <article className="post-section">
          {responseObj.type === 'GraphVideo' &&
            VideoComponent(responseObj.url_download, responseObj.type_download)}
          {responseObj.type === 'GraphReels' &&
            ReelsComponent(responseObj.url_download, responseObj.type_download)}
          {responseObj.type === 'GraphSidecar' &&
            SideCarComponent(responseObj.url_download)}
          {responseObj.type === 'GraphPhoto' &&
            PhotoComponent(responseObj.url_download)}
          {responseObj.type === 'GraphImage' &&
            ImageComponent(responseObj.url_download.data)}
          {responseObj.type === 'GraphFeed' &&
            ImageComponent(responseObj.url_download.data)}
          {responseObj.type === 'GraphStory' && (
            <section className="story-list">
              <div className="position-relative">
                <div className="row justify-content-center">
                  {responseObj.url_download.map((img) => {
                    console.log(
                      '🚀 ~ file: LoadedPost.jsx:144 ~ {responseObj.url_download.map ~ img:',
                      img,
                    );

                    return (
                      <div className="story-item col-md-4 col-12 m-3 position-relative">
                        {img.media_type === 'video' && (
                          <>
                            <video
                              className="story-item"
                              style={{
                                borderRadius: '8px',
                              }}
                              // controls
                              // poster={responseObj.url_download}
                            >
                              <source
                                src={img.url}
                                className="story-media"
                                type="video/mp4"
                              ></source>
                            </video>
                            <div onClick={openModal}>
                              <a
                                className="buttonDownload position-absolute"
                                target="_blank"
                                href={img.url}
                                rel="noreferrer"
                              >
                                BAIXAR
                              </a>
                            </div>
                          </>
                        )}
                        {img.media_type === 'photo' && (
                          <>
                            <img
                              src={img.url}
                              className="story-item "
                              alt=""
                              style={{
                                borderRadius: '8px',
                              }}
                            />
                            <div onClick={openModal}>
                              <a
                                className="buttonDownload position-absolute"
                                target="_blank"
                                href={img.url}
                                rel="noreferrer"
                              >
                                BAIXAR
                              </a>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
          <ModalForms showModal={modal} openModal={setModal} formId={formId} />
        </article>
        {(() => {
          if (responseObj.caption === 'NULL') {
            return <div>No Captions</div>;
          } else if (responseObj.caption) {
            return <p className="post-caption">{responseObj.caption.text}</p>;
          }
        })()}
        {/* <p className="post-caption">{responseObj.caption.text}</p> */}
      </div>
    </>
  );
};

export default LoadedPostDown;
